import React, { Component } from 'react';
import { AppContext } from '../../AppContext.jsx';
import './Logo.css';
import { getLogoDataAsync } from '../../utils/StoreConfigManager.js';
import { LogoClicked } from '../../utils/Analytics.js';
import { constructUrl } from '../../utils/UrlConstructor.js';
import InteractableElement from './InteractableElement';
import BaseImage from './image-components/BaseImage';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import { getSceneInfoAsync } from '../../utils/StoreConfigManager';


const style = {
    width: '80%'
};
const logo = 'https://cdn.obsess-vr.com/ferragamo/logo-header-inverted.svg'
class Logo extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.state = {
            imageSrc: '',
            redirectUrl: ''
        };
        
        getLogoDataAsync()
            .then((logoData) => {
                const imageSrcObject = logoData['imageSrc'];
                const redirectUrlObject = logoData['redirectUrl'];
                const imageSrc = imageSrcObject ? constructUrl(imageSrcObject) : '';
                const redirectUrl = redirectUrlObject ? constructUrl(redirectUrlObject) : '';

                this.setState({
                    imageSrc: imageSrc,
                    redirectUrl: redirectUrl
                });
            })
            .catch(error => console.error(error));
    }

    onClick() {
        LogoClicked();
        const { currentLanguage, currentSceneName, threeJSWorldContext } = this.props;
        const utmParams = `?utm_source=houseofgift&utm_medium=${currentLanguage}&utm_campaign=holiday21&utm_content=${currentSceneName}_logo`;
        const langUrl = (currentLanguage === 'kor_kr') ? 'kor/ko' : currentLanguage.replace('_', '/');
        const url = `https://www.ferragamo.com/shop/${langUrl}${utmParams}`;

        window.open(url, '_blank');

        // getSceneInfoAsync("617b14d07029464b67da1fb3")
        //     .then(scene => {
        //         if (!scene) {
        //             throw new Error('Scene with id 617b14d07029464b67da1fb3 do not exist!');
        //         }

        //         const linkedSceneName = scene['name'];
        //         let targetPath = '/' + linkedSceneName;

        //         if (threeJSWorldContext.history.location.pathname !== targetPath) {
        //             threeJSWorldContext.pushHistoryWithReset(targetPath)
        //         } else {
        //             this.props.setLoadingIconVisibility(false);
        //         }
        //     })
    }

    render() {
        const imageSrc = this.state.imageSrc;
        if (!imageSrc) {
            return <React.Fragment />
        }
        return (
            <div id='topLeftLogo' className='hoverable'>
                <InteractableElement
                    onClick={this.onClick}
                >
                    <BaseImage
                        src={logo}
                        style={style}
                    />
                </InteractableElement>
            </div>
        );
    }
}

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ThreeJSWorldContext.Consumer>
                {threeJSWorldContext => (
                    <Logo
                        {...props}
                        threeJSWorldContext={threeJSWorldContext}
                    />
                )}
            </ThreeJSWorldContext.Consumer>
        )}
    </AppContext.Consumer>
);
